import React from "react";
import SingleAirportContent from "../components/airports/single-airport-content";

const SingleAirport = () => {
  return <SingleAirportContent />;
};

export default SingleAirport;
